export default __webpack_public_path__ + "static/media/img5.d67e5ded.jpg";